import { useEffect } from 'react'

import { appById } from './registry'
import { useActiveApp } from './useActiveApp'

/**
 * Sets `document.title` to the given string, and again whenever it changes.
 */
export const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = title
  }, [title])
}

/**
 * What the tab says wherever no app is resolved. We use the company name, as the suite's name
 * shouldn't be publicly visible.
 */
const FALLBACK_TITLE = 'Regard'

/**
 * Keeps `document.title` on the name of the app the user is in.
 */
export const DocumentTitle = () => {
  const activeApp = appById(useActiveApp())

  useDocumentTitle(activeApp?.name ?? FALLBACK_TITLE)

  return null
}
